import {StationsServiceInterface} from "interfaces/stations-service"
import {BaseBusinessService} from "services/mms/external-api/business/base-business-service"

export class BusinessStationsService
    extends BaseBusinessService
    implements StationsServiceInterface {
    useGetStations() {
        return this.get({endpoint: ''})
    }

    useGetStation(station_id: string) {
        return this.get({endpoint: `/${station_id}`})
    }
}
